export default __webpack_public_path__ + "static/media/character.586b953c.png";